import { nce_changes_order_maker, field_maker } from "helper";

export const nce_changes_field_enum = {
  id: "id",
  start_time_cetcest: "start-time-cetcest",
  end_time_cetcest: "End Time (UTC)",
  area: "1NCE Category",
  tenants: "tenants",
  customer_impact: "customer-impact",
  summary: "summary",
};

const nce_changes_fields = {
  ...field_maker("Key", "Key", "string"),
  ...field_maker("Start Time (UTC)", "Start Time (UTC)", "date"),
  ...field_maker("End Time (UTC)", "End Time (UTC)", "date"),
  ...field_maker("1NCE Category", "1NCE Category", "string"),
  ...field_maker("Tenants", "Tenants", "string"),
  ...field_maker("Change Service Impact", "Change Service Impact", "boolean"),
  ...field_maker("Summary", "Summary", "string"),
};

const nce_changes_order = [
  nce_changes_order_maker(nce_changes_fields["Key"], 160),
  nce_changes_order_maker(nce_changes_fields["Start Time (UTC)"], 220),
  nce_changes_order_maker(nce_changes_fields["End Time (UTC)"], 220),
  nce_changes_order_maker(nce_changes_fields["1NCE Category"], 160),
  nce_changes_order_maker(nce_changes_fields["Tenants"], 130),
  nce_changes_order_maker(nce_changes_fields["Summary"], 500),
  nce_changes_order_maker(nce_changes_fields["Change Service Impact"], 140),
];

export default nce_changes_order;
